import { Box } from "@mui/material";
import { ScoreChart } from "src/components/ScoreChart/ScoreChart";
import { useProductScoresContext } from "src/context/Product/Scores/useProductScores";
import { useEntityScoresOrUnavailable } from "src/context/Scores/useEntityScores";
import { useIsProductUxV2 } from "src/hooks/useIsProductUxV2";
import { getChartData } from "src/utils/questionnaire";

type ProductScoreChartColumnProps = {
    dimension: "components" | "ingredients" | "packagings";
};

export const ProductScoreChartColumn = ({ dimension }: ProductScoreChartColumnProps) => {
    const entityScores = useEntityScoresOrUnavailable();
    const { scores, areScoresRefetching } = useProductScoresContext();
    const isProductUxV2 = useIsProductUxV2();

    if (!entityScores.isAvailable) return null;

    const { scoresWithVariations, lastSelectedVariation } = entityScores;
    const { data, totalScore, maxScore } = getChartData(scores?.olapScores[lastSelectedVariation.scoreId], dimension);

    return (
        <Box flex={2}>
            <ScoreChart
                appearance={isProductUxV2 ? "product-v2" : "legacy"}
                scoresWithVariations={scoresWithVariations}
                selectedVariation={lastSelectedVariation}
                data={data}
                totalScore={totalScore}
                maxScore={maxScore}
                isLoading={areScoresRefetching}
            />
        </Box>
    );
};
